module.exports = __webpack_public_path__ + "static/media/3_Orient-Template-Right.d55ce69c.svg";